import { AccessLevelE } from "../../../models/enums";
import { UserT } from "../../../models/models";
import { DEFAULT_ADVERTISER_AGENCY_ID } from "../../../utils/constants";

export default (user: UserT) => {
  if (user.accessLevel === AccessLevelE.DeliveryServicePrivate) return user.id;
  return DEFAULT_ADVERTISER_AGENCY_ID;
};
